import { css } from "@emotion/react";

const Fotter: React.FC = () => {
  return (
    <div css={mainStyle}>
      <div css={containerStyle}>
        <a
          href="https://cocohana.shueisha.co.jp/story/morimoto/ashigirl/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={
              process.env.REACT_APP_ASSET_BASE_PATH +
              "/img/redirect-to-comic.png"
            }
            alt=""
            css={comicImgStyle}
          />
        </a>
        <a
          href="https://cocohana.shueisha.co.jp/viewer/morimoto/tamano/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={
              process.env.REACT_APP_ASSET_BASE_PATH + "/img/tamanokoshiire.png"
            }
            alt=""
            css={tamanokoshiireImgStyle}
          />
        </a>
        <img
          src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/ashi-girl.png"}
          alt=""
          css={ashiGirlImgStyle}
        />
      </div>
    </div>
  );
};

const mainStyle = css`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const containerStyle = css`
  padding: 15px 0;
  display: flex;
  align-items: center;
`;

const comicImgStyle = css`
  width: 80px;
  margin-right: 6px;
`;

const tamanokoshiireImgStyle = css`
  width: 145px;
  margin-right: 6px;
  margin-bottom: 4px;
`;

const ashiGirlImgStyle = css`
  width: 100px;
`;

export default Fotter;
